import { ViewMode, DisplayMode } from "./types";

export function shouldShowHeader(mode: ViewMode,display_mode: DisplayMode) : boolean {
  return ['icons','single-line'].includes(mode) && display_mode !== 'property';
}
